.skeleton {
    display: block;
    background: linear-gradient(
        90deg,
        var(--tempest-surface) 0%,
        var(--tempest-surface-2) 50%,
        var(--tempest-surface) 100%
    );
    background-size: 200% 100%;
    border-radius: var(--tempest-radius-md);
    animation: tempest-skeleton 1.4s var(--tempest-ease-in-out) infinite;
}

.text {
    height: var(--tempest-text-base);
    border-radius: var(--tempest-radius-sm);
}

.circle {
    border-radius: 50%;
}

.rect {
    border-radius: var(--tempest-radius-md);
}

@keyframes tempest-skeleton {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

@media (prefers-reduced-motion: reduce) {
    .skeleton {
        animation: none;
        background: var(--tempest-surface-2);
    }
}
